import {BaseModal} from '../../js/usga.base-module';
import {Gigya} from '../../js/usga.gigya';

export const ProtectedContentModal = BaseModal.extend({

	init: function (element, options) {
		this._super(element, options);
		this.$dialogs = this.$element.find('.modal__body__content');
	},

	open: function (selector, isCloseDisabled) {
		this.$dialogs.hide().filter(selector).show();
        this.$element.find('.modal__body__close').toggle(!isCloseDisabled);
		this.$element.show();
		this.smallScreenPositionFix();
	},

	'.modal__body__close click': function () {
		this.close();
		Gigya.setProtectedContentModalEvent('login', null);
	},

	'.button.sign-in-button click': function () {
		this.close(true);
		Gigya.login();
	},

	'.button.register-button click': function () {
		this.close(true);
		Gigya.register();
	},

	'.button.connect-button click': function () {
		this.close(true);
		Gigya.connect();
	}
});
